import { shopServiceType } from '@/commonTypes';
import styles from './styles.module.css';
import MainIcons from '@/icons/main';
import RateComponent from '@/components/common/RateComponent';

type ServiceMetaProps = {
  data?: shopServiceType;
};

export default function ServiceMeta({ data }: ServiceMetaProps) {
  const items = [
    {
      key: 'duration',
      icon: <MainIcons.clockIcon />,
      iconClass: styles.grayIcon,
      content: (
        <>
          مدت انجام: <span>{data?.duration}</span>
        </>
      ),
    },
    {
      key: 'distance',
      icon: <MainIcons.locationIcon />,
      iconClass: styles.grayIcon,
      content: (
        <>
          <span>{data?.shop?.distance}</span> از شما
        </>
      ),
    },
    {
      key: 'slot',
      icon: <MainIcons.CalendarIcon fill="var(--green)" />,
      iconClass: styles.greenIcon,
      content: (
        <>
          نزدیک‌ترین نوبت <span>{data?.shop?.closestTime}</span>
        </>
      ),
    },
  ];

  return (
    <div className={styles.container}>
      <span className={styles.rating}>
        <RateComponent
          number={1}
          className={`w-auto`}
          rate={Number(data?.rating)}
          activeFillColor="var(--yellow)"
        />
        {data?.rating}
        <span className={styles.reviewCount}>({data?.commentsCount} نظر)</span>
      </span>

      {items?.map((item) => (
        <span key={item.key} className={styles.item}>
          {item?.icon}
          {item.content}
        </span>
      ))}
    </div>
  );
}
